import LazyImage from "./ui/LazyImage";
import emptyStateImage from "../assets/images/EmptyState.png";

export default function EmptyState() {
  return (
    <div className="w-full min-h-fit pb-12 xl:pb-28 flex flex-col items-center justify-center bg-white">
      <div className="scale-50 xl:scale-[0.4]">
        <LazyImage
          src={emptyStateImage}
          alt="Empty State"
          className="object-fill"
        />
      </div>

      <span className="text-center empty-state-text -mt-12 xl:-mt-28">
        .محتوایی برای نمایش وجود ندارد
      </span>
    </div>
  );
}
